import { writable } from 'svelte/store';

const videoControlStore = () => {
  const { subscribe, set } = writable<boolean>(true);

  return {
    subscribe,
    play: () => set(true),
    pause: () => set(false)
  };
};

export const videoControl = videoControlStore();
